<template>
    <Dashboard
        :title="title"
    >
        <Tabs
            :link="true"
            :tabs="links"
            :lang="$page.props.profile_locale"
        />

        <div class="relative">
            <transition
                enter-active-class="transition duration-500"
                enter-from-class="transform opacity-0"
                enter-to-class="transform opacity-100"
                leave-active-class="transition duration-500"
                leave-from-class="transform opacity-100"
                leave-to-class="transform opacity-0"

                mode="out-in"
            >
                <div class="mt-4" v-if="!loading">
                    <slot />
                </div>
            </transition>

            <Spinner
                class="absolute top-10 h-10 w-10 text-gray-900 z-10"
                v-if="loading"
            />
        </div>

    </Dashboard>
</template>

<script>
    import Dashboard from '@/Layouts/Dashboard';
    import BreezeNavLink from 'COMP/NavLink';
    import Tabs from 'COMP/Tabs/Container';
    import ItemTab from 'COMP/Tabs/Tab';
    import { ref } from '@vue/reactivity';
    import { onMounted, provide } from '@vue/runtime-core';
    import Spinner from 'UI/Spinner';

    export default {
        props: {
            products: Object,
            title: String,
        },
        components: {
            Dashboard, BreezeNavLink, Tabs, ItemTab, Spinner
        },
        setup(props) {
                const links = [
                    {
                        route: 'dashboard.admin.products',
                        title: 'Products',
                        slug: 'product',
                    },
                    {
                        route: 'dashboard.admin.coupon',
                        title: 'Coupons',
                        slug: 'coupons'
                    },
                    {
                        route: 'dashboard.admin.newsletter',
                        title: 'Newsletter',
                        slug: 'newsletter',
                    },
                    {
                        route: 'dashboard.admin.slider',
                        title: 'Slider',
                        slug: 'slider',
                    },
                    {
                        route: 'dashboard.admin.info',
                        title: 'Site info',
                        slug: 'site-info'
                    },
                    {
                        route: 'dashboard.admin.shipping',
                        title: 'Shipping',
                        slug: 'shipping'
                    },
                    {
                        route: 'dashboard.admin.gallery',
                        title: 'Gallery',
                        slug: 'gallery'
                    },
                    {
                        route: 'dashboard.admin.lottery',
                        title: 'Lottery',
                        slug: 'lottery'
                    },
                    {
                        route: 'dashboard.admin.translations',
                        title: 'Translations',
                        slug: 'translations'
                    },
                ];

            const loading = ref(true);
            provide('loading', loading);

            onMounted(() => {
                loading.value = false;
            })

            const current = ref(null);
            links.forEach(el => {
                if(route().current(el.href)) {
                    current.value = el;
                }
            });

            return {
                links,
                current,

                loading
            }
        }

    }
</script>
